import React from "react";
import Features from "../../components/product/Features";

const Product = () => {
  return (
    <section id="home" data-scroll-section className="overflow-x-hidden w-full">
      <Features />
    </section>
  );
};

export default Product;
